import React from 'react';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const PageInDevelopment: React.FC = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="container d-flex flex-column justify-content-center align-items-center vh-100 text-center">
            <h1 className="display-4 text-warning mb-3">{t('PageInDevelopment.Title')}</h1>
            <p className="lead text-muted">
                {t('PageInDevelopment.Description')}
            </p>
            <button className="btn btn-outline-warning" onClick={handleGoHome}>
                {t('PageInDevelopment.GoHome')}
            </button>
        </div>
    );
};

export default PageInDevelopment;
